import React, { useState, useEffect } from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { Button } from "reactstrap";
import { datePickerConstants } from "./constants";
import moment from "moment";
import "./ELCDatePicker.scss";

function ELCDatePicker({ setDropdownOpen, setSelectedDateRange }) {
  const [selectedDates, setSelectedDates] = useState({
    from: new Date(),
    to: new Date(),
  });

  const [tempDates, setTempDates] = useState({
    from: undefined,
    to: undefined,
  });

  useEffect(() => {
    setSelectedDates({ from: new Date(), to: new Date() });
  }, []);

  const setSelectedDateCorrectFormat = (date) => {
    return {
      from: date?.from ? new Date(date.from) : null,
      to: date?.to ? new Date(date.to) : null,
    };
  };

  const handleApplyDates = () => {
    setDropdownOpen(false);
    setSelectedDateRange({
      from: selectedDates?.from
        ? moment(selectedDates?.from).format("DD-MM-YYYY")
        : null,
      to: selectedDates?.to
        ? moment(selectedDates?.to).format("DD-MM-YYYY")
        : null,
    });
  };

  const handleClearDates = () => {
    setSelectedDates({ from: undefined, to: undefined });
  };

  const handleCancelDates = () => {
    setDropdownOpen(false);
    setSelectedDates({ from: undefined, to: undefined });
  };

  const handleStartToToday = () => {
    setSelectedDates({ from: selectedDates.from ?? new Date(), to: null });
  };

  const handleUpUntilEnd = () => {
    setSelectedDates({
      from: null,
      to: selectedDates.to ?? selectedDates.from ?? new Date(),
    });
  };

  return (
    <React.Fragment>
      <div className="datepicker-container">
        <div className="d-flex flex-row justify-content-around w-100">
          <div className="datepicker-list">
            {datePickerConstants.map((datePicker, index) => {
              const [key, value] = Object.entries(datePicker)[0];
              return (
                <div
                  key={index}
                  className="preselect-date"
                  onClick={() =>
                    setSelectedDates({ to: value?.to, from: value?.from })
                  }
                >
                  <span>{key}</span>
                </div>
              );
            })}
            <span className="preselect-date" onClick={handleStartToToday}>
              Start Date to Today
            </span>
            <span className="preselect-date" onClick={handleUpUntilEnd}>
              Up Until Selected End Date
            </span>
          </div>
          <div className="elc-separator-calendar-vertical"></div>
          <div>
            <DayPicker
              mode="range"
              onSelect={setSelectedDates}
              selected={setSelectedDateCorrectFormat(selectedDates)}
            />
          </div>
        </div>
        <div className="elc-separator-calendar-horizontal"></div>
        <div className="datepicker-elc-footer">
          <div>
            {selectedDates?.from || selectedDates?.to ? (
              `${
                selectedDates?.from
                  ? new Date(selectedDates.from).toLocaleDateString("en-US", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })
                  : "Select Date"
              } - ${
                selectedDates?.to
                  ? new Date(selectedDates.to).toLocaleDateString("en-US", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })
                  : "Select Date"
              }`
            ) : (
              <span className="form-text">Please select your dates.</span>
            )}
          </div>
          <div className="d-flex flex-row gap-1">
            <Button
              className="elc-calendar-btn elc-calendar-others"
              onClick={handleCancelDates}
            >
              Cancel
            </Button>
            <Button
              className="elc-calendar-btn elc-calendar-others"
              onClick={handleClearDates}
            >
              Clear
            </Button>
            <Button
              className="elc-calendar-btn elc-calendar-done"
              onClick={handleApplyDates}
            >
              Done
            </Button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default ELCDatePicker;
